<template>
    <section>
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/danh-sach-lop-hoc">Lớp học</router-link></li>
                    <li><router-link to="/danh-sach-lop-hoc">Trang cá nhân</router-link></li>
                    <li><router-link to="">{{ classSchoolName }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="pt-4">
                <h2 class="font-weight-bold">{{ classSchoolName }}</h2>
            </div>
            <div class="row mt-2">
                <div class="col-md-12 col-lg-6 col-xl-5 item item__key input-custom-icon mt-2 display-flex-center">
                    <input v-model.lazy="keyword" type="text" placeholder="Tìm kiếm tên lớp"
                        class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                    <i class="icon-search font-size-16 primary-color"></i>
                </div>
                <div class="col-md-12 col-lg-6 col-xl-4 mt-2">
                    <b-form-select v-model="subjectId" :options="listDataSubject">
                    </b-form-select>
                </div>
            </div>
            <div class="row my-4">
                <div class="col-md-12 col-lg-12 col-xl-7">
                    <div class="box-chart">
                        <div class="text-subtitle"><strong>Biểu đồ điểm trung bình các môn</strong></div>
                        <div class="chart-area">
                            <ChartAveragePoint :subjectId="subjectId" :keyword="keyword" :classId="classId"></ChartAveragePoint>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-xl-5">
                    <div class="box-chart">
                        <div class="text-subtitle"><strong>Biểu đồ tỉ lệ hoàn thành của {{ subjectId > 0 ? ('môn ' + subjectName) : 'các môn' }}</strong></div>
                        <div class="chart-area">
                            <ChartCompleteRate :subjectId="subjectId" :keyword="keyword" :classId="classId"></ChartCompleteRate>
                        </div>
                    </div>
                </div>
            </div>
            <b-tabs class="pre-class-school-list__filter__tabs">
                <b-tab title="Bài tập/bài kiểm tra" @click="handleChangeTab(tabExcercise)"
                    :active="tabActive == tabExcercise">
                    <TabExcercise v-if="tabActive == tabExcercise" :subjectId="subjectId" :keyword="keyword"
                        :classId="classId" />
                </b-tab>
                <b-tab title="Bài giảng điện tử" @click="handleChangeTab(tabElectronicLecture)"
                    :active="tabActive == tabElectronicLecture">
                    <TabElectronicLecture v-if="tabActive == tabElectronicLecture" :subjectId="subjectId"
                        :keyword="keyword" :classId="classId" />
                </b-tab>
                <b-tab title="Kế hoạch bài dạy" @click="handleChangeTab(tabLessonPlanning)"
                    :active="tabActive == tabLessonPlanning">
                    <TabLessonPlaning v-if="tabActive == tabLessonPlanning" :subjectId="subjectId" :keyword="keyword"
                        :classId="classId" />
                </b-tab>
            </b-tabs>
        </div>
    </section>
</template>

<script>
import { getAllTypeFilter } from './../_api/'
import TabExcercise from './_components/TabExcercise'
import TabElectronicLecture from './_components/TabElectronicLecture.vue'
import TabLessonPlaning from './_components/TabLessonPlaning.vue'
import ChartAveragePoint from './_components/ChartAveragePoint.vue'
import ChartCompleteRate from './_components/ChartCompleteRate.vue'
export default {
    components: {
        TabExcercise,
        TabElectronicLecture,
        TabLessonPlaning,
        ChartAveragePoint,
        ChartCompleteRate,
    },
    data() {
        return {
            keyword: '',
            tabActive: 1,
            tabExcercise: 1,
            tabElectronicLecture: 2,
            tabLessonPlanning: 3,
            classSchoolName: '',
            listDataSubject: [],
            subjectId: 0,
            subjectName: '',
            classId: 0
        }

    },
    watch: {
        'classId': 'getListDataSubject',
        'subjectId': 'getSubjectName',
    },
    mounted() {
        this.classId = this.$router.history.current.query.classId * 1
        this.classSchoolName = this.$router.history.current.query.name
    },
    methods: {
        handleChangeTab(tab) {
            this.tabActive = tab
        },
        getListDataSubject() {
            let self = this
            self.listDataSubject = [{ value: 0, text: "Môn học - Tất cả" },]
            this.subjectId = 0
            getAllTypeFilter({ classId: this.classId }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },
        getSubjectName(subjectId) {
            if (this.listDataSubject.length > 0) {
                this.subjectName = this.listDataSubject.filter(x => x.value == subjectId)[0].text || ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-custom-icon i {
    right: 15px;
    top: 4px;
}

.box-chart {
    border: 1px solid #d0d5d8;
    border-radius: 0.6rem;
    padding: 0.8rem 1rem;
    min-height: 10rem;
}
</style>